import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import LandingPage from "./LandingPage";
import AppContainer from "./AppContainer";

function App() {
  return (
    <Router>
      <Routes>
        {/* 랜딩페이지 */}
        <Route path="/" element={<LandingPage />} />

        {/* 기존 앱 */}
        <Route path="/app/*" element={<AppContainer />} />

        {/* 기본적으로 랜딩페이지로 리다이렉트 */}
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </Router>
  );
}

export default App;
